<template>
  <div v-if="displayLastCall && previousCall" class="d-flex flex-column w-100">
    <h6 class="text-left"><strong>Информация из предыдущего разговора с этим клиентом</strong></h6>
    <table class="table">
      <thead>
        <tr>
          <th v-if="name" scope="col">Имя</th>
          <th v-if="result" scope="col">Цель звонка</th>
          <th v-if="message" scope="col">Сообщение</th>
          <th v-if="formatDatetime" scope="col">Дата и время</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th v-if="name">{{ name }}</th>
          <td v-if="result">{{ result.name }}</td>
          <td v-if="message">{{ message }}</td>
          <td v-if="formatDatetime">{{ formatDatetime }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "PreviousCallInfo",
    props: {
      currentCall: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        displayLastCall: false,
        previousCall: null,

        results: [],
        resultId: null,

        message: '',
        name: '',
      };
    },
    computed: {
      systemSettings: function () {
        return this.$store.getters.system_settings
      },
      formatDatetime() {
        return this.previousCall ? this.previousCall.calldate : '';
      },
      result() {
        return this.results.find(v => v.id === this.resultId);
      },
    },
    mounted() {
      this.loadProject();
    },
    methods: {
      loadProject() {
        const route = this.$store.getters.route(`/ajax.php?action=getProject&id=${this.currentCall.project_id}`);
        this.axios.get(route)
          .then(response => {
            this.displayLastCall = !!response.data.project.displayLastCall;
            this.results = response.data.results;

            if (this.displayLastCall) {
              this.loadPreviousCall();
            }
          })
          .catch(err => {});
      },

      loadPreviousCall() {
        const route = this.$store.getters.route(`/ajax.php?action=getPreviousCall&call_id=${this.currentCall.id}`);
        this.axios.get(route)
          .then(response => {
            if (response && response.data && response.data.data) {
              this.previousCall = response.data.data;
              this.resultId = response.data.data.result_id;
              this.loadCallInfoFields();
            }
          })
          .catch(err => {});
      },

      loadCallInfoFields() {
        const route = this.$store.getters.route(`/ajax.php?action=getCallInfoFields&call_id=${this.previousCall.id}`);
        this.axios.get(route)
          .then(response => {
            if (response && response.data && response.data.mainFields) {
              this.message = response.data.mainFields.message;
              this.name = response.data.mainFields.name;
            }
          })
          .catch(err => {});
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/PreviousCallInfo.vue